/* Black Week arcade sign-up page (sections/bw-arcade-hero.liquid).
   1. Countdown: [data-bw-to] holds Danish time "YYYY-MM-DD HH:MM" from the section settings; the boxes count down
      every second, and at zero the hero gets .bw-is-live (the countdown gives way to the "open now" line).
   1b. The pixel font draws Å almost like A (only a notch on top), so each Å/å in pixel text is wrapped in
      .bw-aa and the CSS draws the ring above it. The letter itself stays Å for screen readers and copy/paste.
   2. Optional Klaviyo list: when the hero has a Klaviyo list id ([data-bw-klaviyo]), a sign-up from either form on the
      page (the hero or "BW Arcade: last call") is also sent to that list (Klaviyo's public client API, same call as sections/newsletter-klaviyo.liquid). Without a list id nothing
      extra is sent: the theme's customer form (tags + accepts marketing) is the only route then. */
(function () {
  if (window.BWArcade) return;

  // Danish wall-clock time -> ms since 1970, using Copenhagen's offset on that day (winter +01:00, summer +02:00).
  function cph(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/.exec((s || '').trim());
    if (!m) return NaN;
    var utc = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Copenhagen', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        .formatToParts(new Date(utc)).forEach(function (x) { p[x.type] = x.value; });
      return utc - (Date.UTC(+p.year, p.month - 1, +p.day, +p.hour % 24, +p.minute) - utc);
    } catch (e) {
      return utc - 3600000;
    }
  }

  var two = function (n) { return String(n).padStart(2, '0'); };
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-bw-to]').forEach(function (el) {
      if (el.bwTo === undefined || el.bwToText !== el.dataset.bwTo) { el.bwToText = el.dataset.bwTo; el.bwTo = cph(el.bwToText); }
      if (isNaN(el.bwTo)) return;
      var t = Math.max(0, el.bwTo - now);
      var parts = { d: two(Math.floor(t / 864e5)), h: two(Math.floor(t / 36e5) % 24), m: two(Math.floor(t / 6e4) % 60), s: two(Math.floor(t / 1e3) % 60) };
      Object.keys(parts).forEach(function (k) {
        var n = el.querySelector('[data-bw-' + k + ']');
        if (n && n.textContent !== parts[k]) n.textContent = parts[k];
      });
      el.classList.toggle('bw-is-live', t === 0);
    });
  }

  function rings(root) {
    (root || document).querySelectorAll('.bw.bw-px, .bw .bw-px').forEach(function (el) {
      var walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), found = [], n;
      while ((n = walk.nextNode())) if (/[Åå]/.test(n.nodeValue) && !n.parentNode.classList.contains('bw-aa')) found.push(n);
      found.forEach(function (t) {
        var frag = document.createDocumentFragment();
        t.nodeValue.split(/([Åå])/).forEach(function (part) {
          if (!part) return;
          if (part === 'Å' || part === 'å') {
            var span = document.createElement('span');
            span.className = 'bw-aa';
            span.textContent = part;
            frag.appendChild(span);
          } else {
            frag.appendChild(document.createTextNode(part));
          }
        });
        t.parentNode.replaceChild(frag, t);
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.bw form');
    var hero = document.querySelector('[data-bw-klaviyo]');
    if (!form || !hero) return;
    var cfg = hero.dataset;
    var field = form.querySelector('input[name="contact[email]"]');
    var email = field ? field.value.trim() : '';
    if (!cfg.bwKlaviyo || !cfg.bwKlaviyoKey || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;
    try {
      if (sessionStorage.getItem('bw_sent') === email.toLowerCase()) return;
      sessionStorage.setItem('bw_sent', email.toLowerCase());
    } catch (err) {}
    var tags = form.querySelector('input[name="contact[tags]"]');
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.bwKlaviyoKey), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: cfg.bwSource,
        profile: { data: { type: 'profile', attributes: {
          email: email,
          properties: { 'Signup Source': cfg.bwSource, Campaign: cfg.bwCampaign, 'Shopify Tags': tags ? tags.value : '' },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: cfg.bwKlaviyo } } } } })
    }).catch(function () {});
  });

  window.BWArcade = { tick: tick, rings: rings };
  rings();
  // Theme editor: a section re-rendered after a settings change gets its rings again.
  document.addEventListener('shopify:section:load', function (e) { rings(e.target); });
  tick();
  setInterval(tick, 1000);
})();
